export default __webpack_public_path__ + "static/media/login-logo.5c8af037.svg";